// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3naie","filesListContainer":"PosDisputesFiles_filesListContainer__1390S","filesButton":"PosDisputesFiles_filesButton__1r03e"};